export default "__VITE_ASSET__a369b122__"